<div>
  <ng-template #rangePickerTemplate>
    <td-wb-overlay class="td-wb-datepicker-overlay"
                   [class.td-wb-datepicker-overlay--compact]="calendarStyle() === 'compact'">
      <div class="td-wb-datepicker-range"
           [class.td-wb-datepicker-range--compact]="calendarStyle() === 'compact'">
        <ng-content />
      </div>
    </td-wb-overlay>
  </ng-template>
  <ng-template #dateTemplate>
    <div class="td-wb-datepicker">
      <div class="td-wb-datepicker-range-left"
           [class.td-wb-datepicker-range-left--compact]="calendarStyle() === 'compact'">
        <td-wb-date-picker-inner
          [class.td-wb-datepicker-hidden]="!isStartDateActive && calendarStyle() === 'compact'"
          [class.td-wb-date-picker-inner--compact]="calendarStyle() === 'compact'"
          [parsedDate]="startDateParsed"
          [attr.id]="uniqueId[0]"
          [mode]="mode"
          [minMode]="minMode"
          [maxMode]="maxMode"
          [minDate]="getMinDate('startDate')"
          [maxDate]="getMaxDate('startDate')"
          [showWeeks]="showWeeks"
          [format]="getFormat('startDate')"
          [formatDay]="formatDay"
          [formatMonth]="formatMonth"
          [formatYear]="formatYear"
          [formatDayHeader]="formatDayHeader"
          [formatDayTitle]="formatDayTitle"
          [startingDay]="startingDay"
          [yearRange]="yearRange"
          [disabledDates]="disabledDateInput('startDate')"
          (selectionDone)="onPickerChange($event, 'startDate')">
          <td-wb-day-picker />
          <td-wb-month-picker />
          <td-wb-year-picker />
        </td-wb-date-picker-inner>
      </div>
      <div class="td-wb-datepicker-range-right">
        <td-wb-date-picker-inner
          [class.td-wb-datepicker-hidden]="!isEndDateActive && calendarStyle() === 'compact'"
          [class.td-wb-date-picker-inner--compact]="calendarStyle() === 'compact'"
          [parsedDate]="endDateParsed"
          [attr.id]="uniqueId[1]"
          [mode]="mode"
          [minMode]="minMode"
          [maxMode]="maxMode"
          [minDate]="getMinDate('endDate')"
          [maxDate]="getMaxDate('endDate')"
          [showWeeks]="showWeeks"
          [format]="getFormat('endDate')"
          [formatDay]="formatDay"
          [formatMonth]="formatMonth"
          [formatYear]="formatYear"
          [formatDayHeader]="formatDayHeader"
          [formatDayTitle]="formatDayTitle"
          [startingDay]="startingDay"
          [yearRange]="yearRange"
          [disabledDates]="disabledDateInput('endDate')"
          (selectionDone)="onPickerChange($event, 'endDate')">
          <td-wb-day-picker />
          <td-wb-month-picker />
          <td-wb-year-picker />
        </td-wb-date-picker-inner>
      </div>
    </div>
  </ng-template>
</div>
